// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2cs3K","title":"ClientReferral_title__2GEXL","itemText":"ClientReferral_itemText__i7jSl"};